import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

const PreviewImage = styled.img`
    max-width: 100%;
    max-height: 200px;
    margin: 1rem 0;
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const ImageUploadDialog = ({ open, onClose, file, onSubmit }) => {
    const [filename, setFilename] = useState('');
    const [alt, setAlt] = useState('');
    const previewUrl = file ? URL.createObjectURL(file) : null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({ filename, alt });
        setFilename('');
        setAlt('');
    };

    const handleClose = () => {
        setFilename('');
        setAlt('');
        onClose();
    };

    // Clean up preview URL when dialog closes
    React.useEffect(() => {
        return () => {
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl);
            }
        };
    }, [previewUrl]);

    return (
        <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
            <DialogTitle>Image Details</DialogTitle>
            <DialogContent>
                <Form onSubmit={handleSubmit}>
                    {previewUrl && <PreviewImage src={previewUrl} alt='Upload preview' />}
                    <TextField
                        autoFocus
                        margin='dense'
                        label='File name'
                        fullWidth
                        value={filename}
                        onChange={(e) => setFilename(e.target.value)}
                        required
                        helperText='Enter the desired filename (without extension)'
                    />
                    <TextField
                        margin='dense'
                        label='Alt text'
                        fullWidth
                        value={alt}
                        onChange={(e) => setAlt(e.target.value)}
                        required
                        multiline
                        rows={2}
                        helperText='Describe the image for accessibility'
                    />
                </Form>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSubmit} variant='contained' color='primary' disabled={!filename || !alt}>
                    Upload
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImageUploadDialog;
